import { Box, Button, Checkbox, Heading, Input, Text, VStack } from '@chakra-ui/react'
import React from 'react'

function Transactions() {
  return (
    <>
      <Box>
        <Box>
          <Box display="flex" justifyContent="space-around" alignItems="center">
            <Heading as="h1" fontWeight="400" size="lg">Transactional email plans designed for developers</Heading>
            <Heading as="h1" fontWeight="400" size="md">What is <Button variant="link" size="lg" colorScheme="teal">Transactional Email?</Button></Heading>
          </Box>
          <Box border="1px solid" display="flex" w="80%" m="auto">
            <Box border="1px solid" w="40%">
              <Box textAlign="left"  p="1.5rem" border="1px solid">
                <VStack gap="2rem">
                  <Text fontSize="24px">Enter your estimated sends per month</Text>
                  <Box>
                    <Input mb="1rem" w="80%" fontSize="2xl" variant="flushed" placeholder='Enter email estimate'/>
                    <Checkbox>Dedicated IP for $29.95 / month (Optional)</Checkbox>
                  </Box>
                </VStack>
              </Box>
              <Box>
                <Box>
                  
                </Box>
              </Box>
            </Box>
            <Box></Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default Transactions